"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubMenuItem = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../theme/utils/useTheme");
var _MenuItem = require("./MenuItem");
const iconMap = {
  "lodestar-light": /*#__PURE__*/_react.default.createElement(_lodestarIcons.ArrowRightIcon, null),
  // hardcoded because this does not exist in our icon library
  "ursa-light": /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    fill: "none",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m12.301 10.467-4.107 3.439c-.205.172-.482.102-.619-.156a.668.668 0 0 1-.075-.31V6.56c0-.309.2-.56.447-.56.088 0 .174.033.247.094l4.107 3.44c.205.171.26.52.124.777a.52.52 0 0 1-.124.156Z",
    clipRule: "evenodd"
  }))
};
const SubMenuItem = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    ...rest
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return /*#__PURE__*/_react.default.createElement(_MenuItem.MenuItem, (0, _extends2.default)({
    closeOnSelect: false,
    contentAfter: iconMap[themeMode]
  }, rest, {
    ref: ref
  }), children);
});
exports.SubMenuItem = SubMenuItem;
SubMenuItem.displayName = "SubMenu";
//# sourceMappingURL=SubMenuItem.js.map